<div class="bulk-payment-pdf ml-4 mr-4 pdf-font-{{company?.appsettings?.pdfFontSize}}" [hidden]="!isPreview">
  <table class="width-100p">
    <thead class="report-header">
      <div class="bulk-payment-header">

        <div class="bulk-payment-company flex-start-center pdfLogo-enable" *ngIf="company?.pdfLogo">
          <div class="bulk-payment-logo pr-3 align-self-start">
            <img [ngClass]="pdfLogoType" class="company-logo" [src]="company?.pdfLogo" [alt]="company?.name">
          </div>
        </div>

        <div class="bulk-payment-company flex-start-center" *ngIf="!company?.pdfLogo">
          <div class="bulk-payment-logo pr-3 align-self-start">
            <img class="company-logo" [src]="company?.logo" [alt]="company?.name">
          </div>
          <div class="bulk-payment-details flex-column">
            <span class="font-bold">{{company?.name}}</span>
            <span>{{company?.phone | mask: '(000) 000-0000'}}</span>
            <span>{{company?.email}}</span>
            <span>{{company.formattedAdress}} </span>
            <span *ngIf="company.regNumber && company.regNumber.includes(':')"
              [innerHTML]="this.helperService.formatRegNumber(company?.regNumber)">
            </span>
            <span *ngIf="company.regNumber && !company.regNumber.includes(':')">
              {{'business/GST'|translate}}#: {{company?.regNumber}}
            </span>
          </div>
        </div>

        <div class="bulk-payment-title text-right width-320">
          <div class="bulk-payment-right flex-column">
            <span class="font-bold">{{customer?.fullName}}</span>
            <span class="font-bold" *ngIf="customer?.companyName && customer?.isFleetCustomer">
              {{customer?.companyName}}
            </span>
            <span>{{customer?.phone | mask: '(000) 000-0000'}}</span>
            <span>{{customer?.email}}</span>
            <span>{{customer?.address}}</span>
          </div>
        </div>
      </div>
    </thead>

    <tbody class="report-body">
      <tr>
        <div class="statement-customer flex-between-center">
          <div class="flex-column statement-name">
            <p class="font-bold m-0">{{'receipt-for-bulk-payment'|translate}}</p>
            <p class="m-0 font-600">{{statement?.name}}</p>
            <p class="m-0 font-600">{{payment?.paymentDate | date: 'MMM d, yyyy'}}</p>
          </div>

          <div class="statement-balance-block flex-column">
            <p class="font-bold m-0 text-right">{{'amount-paid'|translate}}: {{statementTotal.paid || 0 | currency:
              usd}}</p>
            <p class="m-0 text-right">
              {{statement?.invoices?.length}} {{'invoice.invoice'|translate}}{{statement?.invoices?.length? 's': ''}},
              {{totalVehicle}}
              {{'invoice.vehicle'|translate}}{{totalVehicle? 's': ''}}
            </p>
          </div>
        </div>
      </tr>

      <tr>
        <app-bulk-payment-line [invoiceLinks]="invoiceLinks" [paymentLinks]="paymentLinks"
          [statementList]="invoicesList || []" [statementTotal]="statementTotal">
        </app-bulk-payment-line>
      </tr>

      <tr>
        <div class="statement-footer flex-start-center mt-3 position-relative">
        </div>
      </tr>
    </tbody>
  </table>
</div>